// common
import React, { useEffect, useRef, useState } from "react"

// redux
import { connect, useSelector } from "react-redux"
import { debounce } from "../../helpers/debounce"
import { mapDispatchProps, mapStateToProps } from "../../store/store"
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock"

// components
import Button from "../button"
import { useLanguage } from "@languages/index"

// Props Interface
interface Props {
  className?: any
  style?: any
  zIndex?: number

  maxHeight?: any
  width?: any

  popup?: any
  sheet?: any
  modal?: any

  setPopup?: any
  preferences?: any
  setPreferences?: any

  setSheet?: (params?: any) => void
  closePopup?: () => void

  onRequestClose?: any
}

const PopupContainer: React.FunctionComponent<Props> = (props: Props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.component.popup }

  const popupRef = useRef()
  const popup = useSelector((state: any) => state.popup.popup)
  const [opened, setIsOpened] = useState(undefined)
  const fadeOutDuration = 300

  const openPopup = () => {
    debounce(() => {
      if (!opened) {
        setIsOpened(true)
        if (popupRef.current && props.sheet?.isVisible == false && props.modal?.isVisible == false) {
          if (!props.preferences.isScrollLocked) {
            // console.log("popup", "scroll-locked");
            // disableBodyScroll(popupRef.current);
            // props.setPreferences({
            //   isScrollLocked: true,
            //   scrollY: window.scrollY,
            // });
          }
        }
      }
    }, 200)
  }

  const closePopup = () => {
    if (popup.onRequestClose) {
      popup.onRequestClose()
    }

    if (popup.preventClose) {
      return false
    }

    if (opened) {
      setIsOpened(false)
    }

    debounce(() => {
      props.setPopup({ isVisible: false })
    }, fadeOutDuration)
  }

  useEffect(() => {
    if (props.popup.isVisible) openPopup()
    // if (!props.popup.isVisible) closePopup();
  }, [props.popup.isVisible])

  useEffect(() => {
    if (popup.closePopup) {
      setTimeout(() => {
        props.setPopup({ isVisible: false })
      }, fadeOutDuration)
    }
  }, [popup])

  if (!props.popup.isVisible) {
    return <></>
  }

  const renderCustomPopup = () => {
    if (!popup.content) {
      return null
    }

    return popup.content()
  }

  const renderDefaultPopup = () => {
    if (popup.content) {
      return null
    }

    const onConfirm = () => {
      if (popup.confirm) {
        popup.confirm()
      }

      closePopup()
    }

    const onCancel = () => {
      if (popup.cancel) {
        popup.cancel()
      }

      closePopup()
    }

    const renderTitle = () => {
      if (!popup.title) {
        return null
      }

      return <span className="prose prose-xl text-black">{popup.title}</span>
    }

    const renderText = () => {
      return (
        <span className="prose prose-md text-black" style={{ whiteSpace: "pre-wrap" }}>
          {popup.text}
        </span>
      )
    }

    const windowBackgroundColor = "white"

    const renderPopupWindow = () => {
      return (
        <div
          className="flex flex-col justify-center align-center p-5"
          style={{ backgroundColor: windowBackgroundColor }}
        >
          <div className="content flex flex-col">
            {renderTitle()}
            {renderText()}
          </div>
          <div className="buttons flex flex-row columns-2 mt-4 gap-1.5">
            {popup.cancel || popup.showCancelButton ? (
              <Button text={languageTexts.cancel} onClick={() => onCancel()} />
            ) : null}
            {!popup.hideConfirmButton ? <Button text={languageTexts.confirm} onClick={() => onConfirm()} /> : null}
          </div>
        </div>
      )
    }

    return renderPopupWindow()
  }

  return (
    <div
      className="popup-container flex flex-col justify-center items-center animate__animated animate__fadeIn"
      style={{
        zIndex: props.popup.zIndex ? props.popup.zIndex : null,
      }}
    >
      <div
        className={popup.className ? "flex popup " + popup.className : "flex popup max-w-lg"}
        style={{
          ...{
            maxHeight: props.popup.maxHeight ? props.popup.maxHeight : null,
          },
        }}
        ref={popupRef}
      >
        {renderCustomPopup()}
        {renderDefaultPopup()}
      </div>

      <div
        className="background-dimmer"
        onClick={(event) => {
          closePopup()
        }}
      />
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchProps)(PopupContainer)
